<template>
  <div v-if="isShow" class="global_withdraw_wrapper">
    <h2 class="access_hidden">글로벌 출금</h2>
    <h2 v-if="isNjPointWithdraw && this.$route.name !== 'GlobalWithdrawInfo'" class="h2">
      {{ $t('global.titlePoint') }}
    </h2>
    <h2 v-else class="h2">{{ $t('global.title') }}</h2>
    <div class="content_withdraw">
      <div v-if="this.$route.name === 'GlobalWithdrawInfo'">
        <withdraw-info />
      </div>
      <div v-if="this.$route.name === 'GlobalWithdrawForm'">
        <withdraw-form />
      </div>
      <div v-if="this.$route.name === 'GlobalWithdrawResult'">
        <withdraw-result />
      </div>
    </div>
  </div>
</template>

<script>
import { goToLoginPage, isLogin, setServiceUrl } from '@/utils';
import WithdrawInfo from '@/components/modules/globalWithdraw/WithdrawInfo';
import WithdrawForm from '@/components/modules/globalWithdraw/WithdrawForm';
import WithdrawResult from '@/components/modules/globalWithdraw/WithdrawResult';
import { mapGetters } from 'vuex';

export default {
  components: {
    WithdrawInfo,
    WithdrawForm,
    WithdrawResult,
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    ...mapGetters('exchange', ['isNjPointWithdraw']),
  },
  created() {
    // 글로벌 출금 관련 페이지에서 공통 로직이 있다면 여기에 추가..
    const { serviceUrl } = this.$route.params;
    if (!serviceUrl) {
      this.$router.push({ path: '/', query: { ...this.$route.query } });
    } else {
      setServiceUrl(serviceUrl);
    }

    if (!isLogin()) {
      goToLoginPage();
    } else {
      this.isShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.global_withdraw_wrapper {
  padding: 50px 30px 0 30px;
  .h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: #050c42;
    font-family: 'NEXONLv1Gothic';
  }
  .content_withdraw {
    margin-top: 40px;
    padding: 30px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07);
    border-radius: 10px;
    @media all and (max-width: 480px) {
      border: none;
      box-shadow: none;
      border-radius: 0;
    }
  }
}

@media all and (max-width: 767px) {
  .global_withdraw_wrapper {
    padding: 30px 15px 0 15px;
    .h2 {
      margin-left: 15px;
    }
    .content_withdraw {
      margin-top: 30px;
      padding: 30px 15px;
    }
  }
}

@media all and (max-width: 480px) {
  .global_withdraw_wrapper {
    padding: 30px 0 0;
  }
}

@media all and (max-width: 360px) {
  .global_withdraw_wrapper {
    .content_withdraw {
      margin-top: 15px;
    }
  }
}
</style>
